import React from "react";
import './index.css';
import { FaRegCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";


const InvitationView = ({teamInfo, selectView})=>{
    return(
        <>
                <div className="introduce-team-title-header" >
                    <p>Bienvenido estimado {teamInfo?.owner}</p>
                    <p>Ustede ha sido invitado al reto de la copa</p>
                </div>
                < motion.div 
                onClick={()=> selectView('welcome')}
                animate={{
    filter: [
      "drop-shadow(0 0 0px green)",
      "drop-shadow(0 0 25px green)",
      "drop-shadow(0 0 0px green)",
    ],
     opacity: [1, 0.85, 1],
    scale: [1, 1.03, 1]
  }}
  transition={{ duration: 2, repeat: Infinity }}
                className="accept-button-invitation">
                    <FaRegCheckCircle />
                    Aceptar

                </motion.div>
                <div className="introduce-team-title-footer" >
                <img width={80} height={80} src={teamInfo?.torneo?.imgPicture} />

                    <p>{`${teamInfo?.torneo?.name}`}</p>
                </div>
        </>
    )
}

export default InvitationView